<template>
    <div class="container">
        <reo-dialog
            v-if="showPaypalDialog"
            class="paypal-dialog"
            :labelOfConfirm="$t('cancel_plan.confirm')"
            :labelOfCancel="$t('cancel_plan.cancel')"
            ref="paypalDialog"
            :title="$t('cancel_plan.paypal_dialog_title')"
            @confirm="showConfirm"
            @cancel="cancel"
            :disableConfirm="paypalDetails.payerAccount.value === ''"
            :isHorizontally="isMobile"
        >
            <div class='paypal-dialog-container'>
                <div class='paypal-dialog-note'>
                    <div class='note'>{{$t('cancel_plan.paypal_account_note1')}}</div>
                    <div class='note'>{{$t('cancel_plan.paypal_account_note2')}}</div>
                </div>
                <div class="paypal-dialog-inner">
                    <section class="reasons-box">
                        <div class="choose-methods">
                            <reo-radio class="circle"
                                type="circle"
                                size="small"
                                v-model="refundMethod"
                                label="Paypal">
                                <span>{{ $t('cancel_plan.selection_paypal') }}</span>
                            </reo-radio>
                        </div>
                        <div v-if='refundMethod==="Paypal"'>
                            <ReoVfxBox
                                v-model="paypalDetails.payerAccount"
                            />
                        </div>
                    </section>
                </div>
            </div>
            <template v-slot:note>
                <p class='warning-tip'><span class='warn-tips red'>* </span>{{$t('cancel_plan.warning_tip')}}</p>
            </template>
        </reo-dialog>

        <reo-dialog
            v-if="dialogConfirmShow"
            class="paypal-dialog confirm"
            :labelOfConfirm="$t('cancel_plan.confirm')"
            :labelOfCancel="$t('cancel_plan.cancel')"
            @confirm="confirmInputPaypal"
            :title="$t('cancel_plan.confirm_dialog_title')"
            @cancel="cancel"
            :isHorizontally="isMobile"
        >
            <div class='paypal-dialog-container'>
                <div class='paypal-dialog-note confirm'>
                    <div class='note'>{{$t('cancel_plan.paypal_account_note1')}}</div>
                    <div class='note'>{{$t('cancel_plan.paypal_account_note2')}}</div>
                </div>
                <div class="paypal-dialog-inner">
                    <section class="reasons-box">
                        <div class="account-box" v-if='refundMethod==="Paypal"'>
                            <div v-for="(item, key) in paypalDetails" :key="key" :name="key" >
                                <label for='payerAccount'><span class='warn-tips red'>* </span>{{item.placeholder}}: </label>
                                <span class="value">{{item.value}}</span>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
            <template v-slot:note>
                <p class='warning-tip'><span class='warn-tips red'>* </span>{{$t('cancel_plan.warning_tip')}}</p>
            </template>
        </reo-dialog>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import ReoDialog from '@/basic/Dialog.vue';
import reoRadio from '@/basic/Radio.vue';
import { mapGetters } from 'vuex';
import ReoVfxBox from '@/basic/ReoVfxBox.vue';

export default Vue.extend({
    components: {
        ReoDialog,
        reoRadio,
        ReoVfxBox
    },
    model: {
        prop: 'showPaypalDialog',
        event: 'change'
    },
    props: {
        showPaypalDialog: Boolean
    },
    data() {

        return {
            dialogConfirmShow: false,
            refundMethod: 'Paypal',

            paypalDetails: {
                payerAccount: {
                    value: '',
                    placeholder: this.$t( 'cancel_plan.paypal_account' ),
                    required: true,
                    half: false,
                    autocomplete: 'paypal-account',
                    error: false
                }
            },
        };

    },
    computed:{
        ...mapGetters<'isMobile'>( ['isMobile'] )
    },
    methods: {
        cancel() {

            this.dialogConfirmShow = false;
            this.$emit( 'change', false );

        },
        confirmInputPaypal() {

            this.$emit( 'confirmInputPaypal', this.paypalDetails.payerAccount.value );
            this.cancel();

        },
        showConfirm() {

            this.$emit( 'change', false );
            this.dialogConfirmShow = true;

        }
    }
});
</script>

<style lang="less" scoped>
.container{
    position: absolute;
    left: 0;
    top: 0;
}
.reo-dialog.paypal-dialog /deep/ .reo-dialog-inner {
    width: 6.4rem;

    @media @snapeak_mobile {
        width: 100%;
    }
}

.reo-dialog.paypal-dialog.confirm {
    & /deep/ .reo-dialog-inner {
        min-height: unset;
    }
}

.paypal-dialog .paypal-dialog-title {
    text-align: left;
    font-size: 0.2rem;
    line-height: 1.4;
    color: #333;
    margin-top: 0.5rem;
    padding: 0 0.4rem;
    font-weight: 500;

    @media @snapeak_mobile {
        font-size: 0.28rem;
    }
}

.paypal-dialog .paypal-dialog-container {
    padding: 0 0.4rem;
}

.paypal-dialog .paypal-dialog-note {
    font-size: 0.24rem;
    margin-top: 0.2rem;
    margin-bottom: 0.3rem;

    &.confirm {
        margin-bottom: 0.16rem;

        @media @snapeak_mobile {
            margin-bottom: 0.12rem;
        }
    }

    @media @snapeak_mobile {
        width: unset;
        padding-right: 0.3rem;
    }

    & /deep/ .note {
        font-size: 0.18rem;
        text-align: left;
        margin-bottom: 0.2rem;
        line-height: 1.2;

        &:last-child {
            margin-bottom: 0;
        }

        @media @snapeak_mobile {
            font-size: 0.26rem;
            margin-bottom: 0.12rem;
        }
    }
}

.paypal-dialog .paypal-dialog-inner {
    font-size: 0.24rem;

    @media @snapeak_mobile {
        width: unset;
        padding-right: 0.3rem;
    }

    .reasons-box {
        text-align: left;

        .info-grey {
            color: #333;
            font-weight: 400;
            padding-bottom: 0.04rem;
            display: inline-block;
        }
    }

    .choose-methods {
        margin-bottom: 0.1rem;

        span {
            color: @font_primary;
        }

        @media @snapeak_mobile {
            margin-bottom: 0.16rem;
        }
    }

    .account-box {
        display: flex;
        flex-direction: column;

        div {
            margin-bottom: 0.15rem;
            overflow-wrap: anywhere;
        }

        label,
        span {
            font-size: 0.18rem;
            font-weight: 500;

            @media @snapeak_mobile {
                font-size: 0.26rem;
            }
        }

        .value {
            max-height: 1rem;
            overflow-y: auto;
            overflow-y: overlay;
            display: block;

            @media @snapeak_mobile {
                max-height: 2rem;
            }
        }
    }

    .info-grey {
        font-size: 0.18rem;
        line-height: 1.4;

        @media @snapeak_mobile {
            font-size: 0.26rem;
        }
    }
}

.paypal-dialog .warning-tip {
    padding: 0 0.4rem;
    font-size: 0.18rem;
    text-align: left;

    @media @snapeak_mobile {
        font-size: 0.26rem;
        margin: 0 !important;
    }
}
</style>
